import { render, staticRenderFns } from "./columnItemList.vue?vue&type=template&id=37e25098&scoped=true&"
import script from "./columnItemList.vue?vue&type=script&lang=js&"
export * from "./columnItemList.vue?vue&type=script&lang=js&"
import style0 from "./columnItemList.vue?vue&type=style&index=0&id=37e25098&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e25098",
  null
  
)

export default component.exports